module.exports = __webpack_public_path__ + "static/img/5506_phase_function_Paper_Points.ad85a08.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/5506_phase_function_Paper_Points.png
// module id = oWtP
// module chunks = 0